const operatorActionChoices = {
  "*": ["Started gas ramp", "Paused gas ramp", "Cut gas flow", "Paused pressure ramp", "Opened sparger set"],
  Skokie: [
    "Adjusted inlet gas composition",
    "Decreased ABS flow",
    "Decreased AF dosing",
    "Decreased KOH flow",
    "Decreased MetSelect flow",
    "Decreased NaHS flow",
    "Decreased agitation ramp",
    "Decreased bleed",
    "Decreased gas ramp",
    "Decreased media flow",
    "Decreased permeate",
    "Decreased pressure ramp",
    "Decreased sulfur factor",
    "Ended run",
    "Increased ABS flow",
    "Increased AF dosing",
    "Increased KOH flow",
    "Increased MetSelect flow",
    "Increased NaHS flow",
    "Increased VD feed flow",
    "Increased VD steam",
    "Increased agitation ramp",
    "Increased bleed",
    "Increased gas ramp",
    "Increased media flow",
    "Increased permeate",
    "Increased pressure ramp",
    "Increased sulfur factor",
    "Paused agitation ramp",
    "Started VD circulation",
    "Started agitation ramp",
    "Started bleed flow",
    "Started continuous AF dosing",
    "Started permeate draw",
    "Started pressure ramp",
    "Turned continuous",
  ],
  "AM Ghent": [
    "Started pressure increase ramp",
    "Started pressure decrease ramp",
    "Started Sulzer loop circulation",
    "Started up MVRs and began ethanol stripping",
    "Prepared new nutrient solution slurry tank",
    "Prepared new MS tank",
    "FREEZE activated on reactor",
    "Sulzer loop trip activated on reactor",
  ],
}

export default operatorActionChoices
